import type { SVGProps } from "react";
import { withCustomIcon } from "./withCustomIcon";

const DesignPendingIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    className="tenera-icon"
    viewBox="0 0 24 24"
    {...props}
  >
    <g fill="currentColor">
      <path
        fill="currentColor"
        d="M2.7054,23V1h9.6002v5.9996l5.5999.0004v4.6121c.3437.0642.6766.1566,1,.2704v-6.2101L13.5001,0H1.7054v24h11.2904c-.446-.2859-.8564-.6208-1.223-1H2.7054ZM13.3055,1.2454l4.5308,4.7547-4.5308-.0004V1.2454Z"
        className="primary"
      />
      <path
        fill="currentColor"
        d="M16.3051,10.6227c0-.2764-.2236-.5-.5-.5H4.8055c-.2764,0-.5.2236-.5.5s.2236.5.5.5h10.9995c.2764,0,.5-.2236.5-.5Z"
        className="primary"
      />
      <path
        fill="currentColor"
        d="M11.6482,13.7037h-6.8427c-.2764,0-.5.2236-.5.5s.2236.5.5.5h6.0836c.2224-.3572.4763-.6912.759-1Z"
        className="primary"
      />
      <path
        fill="currentColor"
        d="M4.8055,17.2848c-.2764,0-.5.2236-.5.5s.2236.5.5.5h2.75c.2764,0,.5-.2236.5-.5s-.2236-.5-.5-.5h-2.75Z"
        className="primary"
      />
      <path
        fill="currentColor"
        d="M16.1527,14.5485v3.5283l-1.6787,1.6787c-.1953.1953-.1953.5117,0,.707.0977.0977.2256.1465.3535.1465s.2559-.0488.3535-.1465l1.9717-1.9717v-3.9424c0-.2764-.2236-.5-.5-.5s-.5.2236-.5.5Z"
        className="primary"
      />
      <path
        fill="currentColor"
        d="M21.515,13.5469v-.6435c0-.2764-.2236-.5-.5-.5-.2137,0-.3928.1351-.4644.3235-.021.0552-.0356.1139-.0356.1765v1.1712c-1.0425-.9609-2.4145-1.5076-3.8701-1.5076-3.1523,0-5.7168,2.5645-5.7168,5.7168s2.5645,5.7158,5.7168,5.7158c.3096,0,.6182-.0244.918-.0732.2725-.0439.457-.2998.4131-.5732-.043-.2715-.2959-.4658-.5732-.4131-.2461.0391-.502.0596-.7578.0596-2.6006,0-4.7168-2.1152-4.7168-4.7158s2.1162-4.7168,4.7168-4.7168c1.2638,0,2.4458.5052,3.3203,1.376h-1.4892c-.2764,0-.5.2236-.5.5s.2236.5.5.5h3.0391v-2.3961Z"
        className="primary"
      />
      <path
        fill="currentColor"
        d="M19.8881,21.5211c-.1074.1045-.2207.2051-.3389.2998-.2148.1738-.249.4883-.0762.7031.0996.123.2441.1865.3896.1865.1104,0,.2217-.0361.3135-.1104.1436-.1162.2803-.2363.4092-.3623.1982-.1934.2021-.5098.0098-.707-.1943-.1973-.5107-.2012-.707-.0098Z"
        className="primary"
      />
      <path
        fill="currentColor"
        d="M22.2318,17.2301c-.0449-.2734-.2949-.4561-.5732-.415-.2725.0439-.458.3008-.415.5732.0244.1504.041.3018.0518.4521.0186.2637.2383.4648.498.4648.0127,0,.0244,0,.0361-.001.2754-.0195.4834-.2588.4639-.5342-.0127-.1797-.0332-.3604-.0615-.54Z"
        className="primary"
      />
    </g>
    <path
      fill="currentColor"
      d="M21.6996,19.3024c-.2627-.085-.5439.0576-.6309.3203-.0459.1426-.0996.2832-.1602.4199-.1104.2529.0039.5479.2568.6592.0654.0283.1338.042.2012.042.1924,0,.376-.1113.458-.2988.0723-.166.1377-.3379.1953-.5117.0859-.2627-.0576-.5449-.3203-.6309Z"
      className="accent"
    />
  </svg>
);

export default withCustomIcon(DesignPendingIcon);